import React from 'react'
import  {Hero ,CountupCard ,AboutUs, Services,Reviews,Fotter ,Blogs, TimeLine} from '../components'
import { Header } from '../components/layout'


function Home() {
  return (
<> <Header active={1} />

         <Hero  />
         <CountupCard />
         <AboutUs />
         <Services />
       
          <Reviews />
          <Blogs />
          <Fotter />

</>
    
       
   
  )
}

export default Home